import Translations from "@translate/components/EmailLogin/emailLoginErrors";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const extractErrorCodeFromMessage = (message: string): number | null => {
  if (typeof message !== "string") {
    return null;
  }

  const match = message.match(/"code"\s*:\s*(-?\d+)/);
  if (!match) {
    return null;
  }

  const numeric = Number(match[1]);
  return Number.isNaN(numeric) ? null : numeric;
};

export const getErrorMessageFromError = (
  err: unknown,
  fallbackMessage: string,
): string => {
  const ERROR_CODE_MESSAGE_MAP: Record<number, string> = {
    106039: I18n.t("Invalid verification code. Please try again."),
    106038: I18n.t("Invalid email address. Please try again."),
    106040: I18n.t(
      "Verification code sent too frequently. Please try again later.",
    ),
    100999: I18n.t("operation too many times. Please try again tomorrow."),
  };

  if (!(err instanceof Error) || typeof err.message !== "string") {
    return fallbackMessage;
  }

  const code = extractErrorCodeFromMessage(err.message);
  if (code != null && ERROR_CODE_MESSAGE_MAP[code]) {
    return ERROR_CODE_MESSAGE_MAP[code];
  }

  return err.message || fallbackMessage;
};
